/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/08/01
 * @created by      :   ANS902 – quanlh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
// import repository from './repository';

const dataInit = {
    bank_branch_office_cd: '',
    bank_branch_office_name: '',
    bank_cd: '',
    bank_name: '',
    mode: 0,
    pageSize: 20,
    pageNo: 1
};

const listDataInit = [
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    },
    {
        bank_branch_office_cd: '019',
        bank_cd: '0001',
        bank_branch_office_name: '東京営業部',
        bank_name: 'みずほ'
    }
];

export default {
    namespaced: true,
    state: {
        listData: [],
        data: { ...dataInit },
        msgNoData: '該当するデータが存在しません。',
        totalRows: 0
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません。';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setTotalRows(state, data) {
            state.data.page_no = data.page ?? [];
            state.data.page_size = data.pagesize ?? [];
            state.totalRows = data.total_rows;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        },
        setMessage(state, data) {
            state.msgNoData = data;
        }
    },
    actions: {
        /**
         * search area info
         * -----------------------------------------
         * @author : hainn - 2024/10/16 - create
         * @params :
         * @access : private
         */
        searchAreaInfo(context) {
            try {
                const listData = listDataInit;
                if (listData.length > 0) {
                    context.commit('setListData', listDataInit);
                } else {
                    context.commit('setListData', []);
                    context.commit('setMessage', '該当するデータが存在しません。');
                }
                let pag = {
                    page: 1,
                    pagesize: 20,
                    total_rows: listDataInit.length
                };
                context.commit('setTotalRows', pag);
                // repository.searchAreaInfo(param).then((res) => {
                //     const { data } = res;
                //     if (data.Code === 200) {
                //         const listData = listDataInit;
                //         if (listData.length > 0) {
                //             context.commit('setListData', listData);
                //         } else {
                //             context.commit('setListData', []);
                //             context.commit('setMessage', '該当するデータが存在しません。');
                //         }
                //         if (param.callback) {
                //             param.callback(data);
                //         }
                //         context.commit('setTotalRows', data.Data.paging);
                //     }
                // });
            } catch (e) {
                console.log('searchCommonAreaInfo: ' + e.message);
            }
        }
    }
};
